import * as types from '../../mutation-types'
import RaceQuoteService from '../../../services/raceQuote'

const actions = {
  createOne ({ commit, state }, quote) {
    return RaceQuoteService.createOne(quote)
  },

  updateOne ({ commit, state }, quote) {
    return RaceQuoteService.updateOne(quote)
  },
  getOne ({ commit, state }, date) {
    return RaceQuoteService.getOne(date)
  }

}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/raceQuote/actions.js